'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var generateHelpUrl = require('@sanity/generate-help-url');

var enc = encodeURIComponent;
var materializeError = 'You must either:\n  - Pass `projectId` and `dataset` to the block renderer\n  - Materialize images to include the `url` field.\n\nFor more information, see ' + generateHelpUrl('block-content-image-materializing');

var getQueryString = function getQueryString(options) {
  var query = options.imageOptions;
  var keys = Object.keys(query);
  if (!keys.length) {
    return '';
  }

  var params = keys.map(function (key) {
    return enc(key) + '=' + enc(query[key]);
  });
  return '?' + params.join('&');
};

var buildUrl = function buildUrl(props) {
  var node = props.node,
      options = props.options;

  var asset = node.asset;

  if (!asset) {
    throw new Error('Image does not have required `asset` property');
  }

  var qs = getQueryString(options);

  if (asset.url) {
    return asset.url + qs;
  }

  var ref = asset._ref;
  if (!ref) {
    throw new Error('Invalid image reference in block, no `_ref` found on `asset`');
  }

  var projectId = options.projectId,
      dataset = options.dataset;

  if (!projectId || !dataset) {
    throw new Error(materializeError);
  }

  var _ref$split = ref.split('-'),
      _ref$split2 = _slicedToArray(_ref$split, 4),
      type = _ref$split2[0],
      id = _ref$split2[1],
      dimensions = _ref$split2[2],
      ext = _ref$split2[3];

  var url = 'https://cdn.sanity.io/' + type + 's/' + projectId + '/' + dataset + '/' + id + '-' + dimensions + '.' + ext + qs;
  return url;
};

module.exports = buildUrl;
//# sourceMappingURL=getImageUrl.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sanity/block-content-to-hyperscript/lib/getImageUrl.js
// module id = 50
// module chunks = 0